document.addEventListener("DOMContentLoaded", () => {
  const disclaimer = document.querySelectorAll('[data-spam-detection-disclaimer] a');
  if (disclaimer) {
    disclaimer.forEach(a => {
      a.setAttribute('rel', 'nofollow');
    });
  }
  const judgeReview = localStorage.getItem("judgeReview");
  if(!judgeReview) {
    const scoreEle = document.querySelector('.jdgm-carousel-wrapper .jdgm-all-reviews-rating');
    const numberReviewsEle = document.querySelector('.jdgm-carousel-wrapper .jdgm-carousel-number-of-reviews');
    if(scoreEle && numberReviewsEle) {
      localStorage.setItem("judgeReview", JSON.stringify({
        score: scoreEle.dataset.score,
        numberReviews: numberReviewsEle.dataset.numberOfReviews
      }))
    }
  }
});
/*
 * Título de la ficha de producto en una sola línea.
 *
 * Se mide el ancho real del texto (el span interno) y se baja el tamaño hasta
 * que quepa, entre --pdp-title-max y --pdp-title-min. Se mide el span y no el
 * h1 porque scrollWidth no es fiable en un elemento recortado.
 */
(() => {
  const TITLE_SELECTOR = 'h1.product-title[data-fit-title]';
  const MOBILE_MIN = 13;

  const readPx = (styles, property, fallback) => {
    const value = parseFloat(styles.getPropertyValue(property));
    return Number.isFinite(value) ? value : fallback;
  };

  const fitTitle = (title) => {
    const text = title.querySelector('.product-title__text');
    if (!text) return;

    const holder = title.closest('[data-block-type="title"]') || title.parentElement;
    if (!holder) return;

    const holderStyles = getComputedStyle(holder);
    const available =
      holder.clientWidth -
      parseFloat(holderStyles.paddingLeft) -
      parseFloat(holderStyles.paddingRight);
    if (available <= 0) return;

    const styles = getComputedStyle(title);
    const max = readPx(styles, '--pdp-title-max', 15);
    const min = readPx(styles, '--pdp-title-min', 9);
    // En móvil no se baja de 13px: si no cabe en una línea a ese tamaño, el título pasa a dos líneas
    const mobile = window.matchMedia('(max-width: 699px)').matches;
    const floor = mobile ? Math.max(min, MOBILE_MIN) : min;

    title.style.removeProperty('white-space');
    title.style.setProperty('font-size', `${max}px`, 'important');
    const needed = text.getBoundingClientRect().width;
    if (needed <= 0 || needed <= available) return;

    // 0.99 deja un pelo de margen para que el redondeo del navegador no corte la última letra
    const fitted = Math.floor(max * (available / needed) * 0.99 * 100) / 100;

    if (fitted < floor) {
      title.style.setProperty('white-space', 'normal', 'important');
      return;
    }

    title.style.setProperty('font-size', `${Math.max(floor, fitted)}px`, 'important');
  };

  const fitAll = () => document.querySelectorAll(TITLE_SELECTOR).forEach(fitTitle);

  const observedWidths = new WeakMap();
  const resizeObserver =
    'ResizeObserver' in window
      ? new ResizeObserver((entries) => {
          entries.forEach(({ target }) => {
            // Solo interesa el ancho: el alto cambia al reajustar la fuente y volvería a disparar el observer
            const width = target.clientWidth;
            if (observedWidths.get(target) === width) return;
            observedWidths.set(target, width);
            target.querySelectorAll(TITLE_SELECTOR).forEach(fitTitle);
          });
        })
      : null;

  const observeHolders = () => {
    if (!resizeObserver) return;
    document.querySelectorAll(TITLE_SELECTOR).forEach((title) => {
      const holder = title.closest('[data-block-type="title"]');
      if (holder) resizeObserver.observe(holder);
    });
  };

  const start = () => {
    fitAll();
    observeHolders();
    // La fuente puede llegar después del primer pintado y cambiar el ancho del texto
    if (document.fonts) document.fonts.ready.then(fitAll);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();

/*
 * Pestañas de la ficha (Descripción, Productor, Información nutricional y
 * Premios). Todo el contenido ya viene en el HTML; aquí solo se cambia cuál se ve.
 */
(() => {
  const TAB_SELECTOR = '[data-pdp-tabs] [role="tab"]';

  const selectTab = (tab) => {
    const group = tab.closest('[data-pdp-tabs]');
    [...group.querySelectorAll('[role="tab"]')]
      .filter(item => item.closest('[data-pdp-tabs]') === group)
      .forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        item.tabIndex = active ? 0 : -1;
        const panel = document.getElementById(item.getAttribute('aria-controls'));
        if (panel) panel.hidden = !active;
      });
  };

  document.addEventListener('click', (event) => {
    const tab = event.target.closest(TAB_SELECTOR);
    if (tab) selectTab(tab);
  });

  document.addEventListener('keydown', (event) => {
    const tab = event.target.closest(TAB_SELECTOR);
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

    const tabs = [...tab.parentElement.querySelectorAll('[role="tab"]')];
    let index = tabs.indexOf(tab);
    if (event.key === 'ArrowRight') index = (index + 1) % tabs.length;
    if (event.key === 'ArrowLeft') index = (index - 1 + tabs.length) % tabs.length;
    if (event.key === 'Home') index = 0;
    if (event.key === 'End') index = tabs.length - 1;

    event.preventDefault();
    tabs[index].focus();
    selectTab(tabs[index]);
  });
})();

/*
 * "Ver más detalles" del resumen: baja hasta las pestañas y deja abierta la de
 * Descripción. Si una plantilla no tuviera pestañas, abre el primer desplegable.
 */
(() => {
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-pdp-more-details]');
    if (!link) return;

    const target =
      document.getElementById('descripcion-completa') ||
      document.querySelector('.product-info [data-block-type="accordion"]');
    if (!target) return;

    event.preventDefault();

    const descriptionTab = target.querySelector('[role="tab"][data-pestana="descripcion"]');
    if (descriptionTab) {
      descriptionTab.click();
      const firstSubtab = target.querySelector('.pdp-subtabs [role="tab"]');
      if (firstSubtab) firstSubtab.click();
    } else {
      const details = target.matches('details') ? target : target.querySelector('details');
      if (details && !details.open) details.open = true;
    }

    target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  });
})();

/*
 * Galería fija en escritorio. Si cabe en pantalla, se queda arriba bajo la
 * cabecera; si es más alta, se engancha por abajo para que se lleguen a ver
 * todas las fotos antes de quedarse quieta.
 */
(() => {
  const GALLERY_SELECTOR = '.product > .product-gallery';
  const GAP = 24;
  const desktop = window.matchMedia('(min-width: 1000px)');

  const update = () => {
    document.querySelectorAll(GALLERY_SELECTOR).forEach((gallery) => {
      if (!desktop.matches) {
        gallery.style.removeProperty('top');
        return;
      }

      const header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-area-height')) || 0;
      const top = Math.min(header + GAP, window.innerHeight - gallery.offsetHeight - GAP);
      gallery.style.top = `${top}px`;
    });
  };

  const start = () => {
    update();
    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(update);
      document.querySelectorAll(GALLERY_SELECTOR).forEach((gallery) => observer.observe(gallery));
    }
  };

  window.addEventListener('resize', update);
  desktop.addEventListener('change', update);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/*
 * Flechas de los carruseles de la ficha (opiniones y blog). Cada flecha indica
 * con data-pdp-carrusel-objetivo qué lista mueve y con data-direccion hacia dónde;
 * avanza una tarjeta cada vez.
 */
(() => {
  document.addEventListener('click', (event) => {
    const flecha = event.target.closest('[data-pdp-carrusel-objetivo]');
    if (!flecha) return;

    const lista = document.querySelector(flecha.dataset.pdpCarruselObjetivo);
    if (!lista) return;

    const tarjeta = lista.firstElementChild;
    const hueco = parseFloat(getComputedStyle(lista).columnGap) || 0;
    const paso = tarjeta ? tarjeta.getBoundingClientRect().width + hueco : lista.clientWidth;

    lista.scrollBy({ left: paso * Number(flecha.dataset.direccion || 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });
})();

/*
 * Botón de la barra de newsletter: abre el popup de Klaviyo de la oferta del
 * primer pedido, el mismo que ya usa la tienda, para que el suscriptor entre en
 * su flujo y reciba el aceite gratis.
 */
(() => {
  document.addEventListener('click', (event) => {
    const boton = event.target.closest('[data-klaviyo-formulario]');
    if (!boton) return;

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', boton.dataset.klaviyoFormulario]);
  });
})();

/*
 * Selector de variante de la barra flotante → píldoras de la ficha.
 * La barra solo cambiaba el id oculto del formulario, así que la ficha seguía
 * enseñando la variante anterior (precio, fotos y píldoras) y el botón principal
 * podía añadir otra distinta. Aquí se marcan en la ficha las mismas opciones y se
 * lanza un solo "change", para que el tema recalcule todo como si se hubiera
 * pulsado la píldora.
 */
(() => {
  // Al cambiar a una variante con otra foto, la galería en rejilla de escritorio sube la
  // página hasta esa foto. Desde la barra flotante eso te lleva arriba y la barra se va,
  // así que durante un momento tras cambiar desde la barra se ignora ese salto.
  let ultimoCambioDesdeBarra = 0;
  const scrollIntoViewOriginal = Element.prototype.scrollIntoView;
  Element.prototype.scrollIntoView = function (...args) {
    if (Date.now() - ultimoCambioDesdeBarra < 3000 && this.closest?.('product-gallery')) return;
    return scrollIntoViewOriginal.apply(this, args);
  };

  document.addEventListener('change', (event) => {
    const select = event.target.closest('select.sticky-variant-select, select.sticky-variant-select-desktop');
    if (!select) return;

    ultimoCambioDesdeBarra = Date.now();

    const option = select.options[select.selectedIndex];
    let valores = [];
    try { valores = JSON.parse(option?.dataset.opciones || '[]'); } catch { return; }
    const picker = document.querySelector(`variant-picker[form-id="${select.getAttribute('form')}"]`);
    if (!picker || !valores[0]) return;

    let ultimoCambiado = null;

    valores.forEach((valor, indice) => {
      picker.querySelectorAll(`input[type="radio"][data-option-position="${indice + 1}"]`).forEach((input) => {
        const label = picker.querySelector(`label[for="${CSS.escape(input.id)}"]`);
        if (label && label.dataset.name === valor && !input.checked) {
          input.checked = true;
          ultimoCambiado = input;
        }
      });
    });

    if (ultimoCambiado) ultimoCambiado.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();

/*
 * Opiniones de la ficha. El servidor pinta las 5 que trae el metacampo de Judge.me; si el
 * producto tiene más, al acercarse el carrusel a la pantalla se piden hasta 30 a la misma
 * llamada que usa el widget de Judge.me para paginar y se añaden las que falten, con el
 * mismo marcado. Si la llamada falla, se quedan las 5 del servidor.
 */
(() => {
  const ESTRELLA = '<path d="M6 0v8.635L2.292 11 3.48 6.87 0 4.202l4.443-.187L6 0Zm0 0v8.635L9.708 11 8.52 6.87 12 4.202l-4.443-.187L6 0Z"/>';

  const tarjeta = (rev, textoVerificado) => {
    const puntos = Math.max(0, Math.min(5, Number(rev.querySelector('[data-score]')?.dataset.score) || 0));
    const autor = rev.querySelector('.jdgm-rev__author')?.textContent.trim() || '—';
    let titulo = rev.querySelector('.jdgm-rev__title')?.textContent.trim() || '';
    const parrafos = [...(rev.querySelector('.jdgm-rev__body')?.querySelectorAll('p') || [])].map((p) => p.textContent.trim()).filter(Boolean);
    const textoPlano = parrafos.join(' ');
    if (titulo && textoPlano.startsWith(titulo)) titulo = '';
    if (!titulo && !textoPlano) return null;

    const li = document.createElement('li');
    li.className = 'pdp-review';
    li.dataset.reviewId = rev.dataset.reviewId || '';

    const estrellas = document.createElement('span');
    estrellas.className = 'pdp-review__estrellas';
    estrellas.setAttribute('role', 'img');
    estrellas.setAttribute('aria-label', `${puntos}/5`);
    estrellas.innerHTML = Array.from({ length: 5 }, (_, i) => `<svg class="pdp-review__estrella${i >= puntos ? ' is-off' : ''}" aria-hidden="true" focusable="false" viewBox="0 0 12 11">${ESTRELLA}</svg>`).join('');
    li.append(estrellas);

    if (titulo) {
      const p = document.createElement('p');
      p.className = 'pdp-review__titulo';
      p.textContent = titulo;
      li.append(p);
    }

    if (parrafos.length) {
      const texto = document.createElement('div');
      texto.className = 'pdp-review__texto';
      parrafos.forEach((contenido) => {
        const p = document.createElement('p');
        p.textContent = contenido;
        texto.append(p);
      });
      li.append(texto);
    }

    const fotos = [...rev.querySelectorAll('.jdgm-rev__pic-img[data-src]')].slice(0, 3);
    if (fotos.length) {
      const contenedor = document.createElement('div');
      contenedor.className = 'pdp-review__fotos';
      fotos.forEach((foto) => {
        const img = document.createElement('img');
        img.src = foto.dataset.src;
        img.alt = '';
        img.width = 64;
        img.height = 64;
        img.loading = 'lazy';
        contenedor.append(img);
      });
      li.append(contenedor);
    }

    const pie = document.createElement('p');
    pie.className = 'pdp-review__autor';
    pie.textContent = autor;
    if (rev.dataset.verifiedBuyer === 'true') {
      const verificado = document.createElement('span');
      verificado.className = 'pdp-review__verificado';
      verificado.textContent = textoVerificado;
      pie.append(verificado);
    }
    li.append(pie);

    return li;
  };

  const cargarMas = async (seccion) => {
    const lista = seccion.querySelector('.pdp-reviews__list');
    const { total, shop, productId, textoVerificado } = seccion.dataset;
    if (!lista || !shop || !productId || !(Number(total) > lista.children.length)) return;

    const url = `https://api.judge.me/reviews/reviews_for_widget?url=${encodeURIComponent(shop)}&shop_domain=${encodeURIComponent(shop)}&platform=shopify&page=1&per_page=30&product_id=${encodeURIComponent(productId)}`;

    try {
      const respuesta = await fetch(url);
      if (!respuesta.ok) return;
      const datos = await respuesta.json();
      const documento = new DOMParser().parseFromString(datos.html || '', 'text/html');
      const yaEstan = new Set([...lista.children].map((li) => li.dataset.reviewId));

      documento.querySelectorAll('.jdgm-rev[data-review-id]').forEach((rev) => {
        if (yaEstan.has(rev.dataset.reviewId)) return;
        const li = tarjeta(rev, textoVerificado);
        if (li) lista.append(li);
      });

      lista.dispatchEvent(new Event('scroll'));
    } catch (error) {
      // Sin conexión con Judge.me: se quedan las opiniones del servidor
    }
  };

  const iniciar = () => {
    const secciones = document.querySelectorAll('[data-pdp-reviews]:not([data-cargadas])');
    if (!secciones.length) return;

    const observador = 'IntersectionObserver' in window
      ? new IntersectionObserver((entradas) => {
          entradas.forEach(({ target, isIntersecting }) => {
            if (!isIntersecting) return;
            observador.unobserve(target);
            cargarMas(target);
          });
        }, { rootMargin: '600px 0px' })
      : null;

    secciones.forEach((seccion) => {
      seccion.dataset.cargadas = 'true';
      if (observador) observador.observe(seccion); else cargarMas(seccion);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();

/*
 * Estado de las flechas de los carruseles de la ficha (opiniones y blog): se desactiva la
 * de atrás al principio y la de delante al final, y se ocultan si todo cabe sin moverse.
 */
(() => {
  const actualizar = (lista) => {
    const flechas = document.querySelectorAll(`[data-pdp-carrusel-objetivo="#${CSS.escape(lista.id)}"]`);
    if (!flechas.length) return;

    const maximo = lista.scrollWidth - lista.clientWidth;
    const cabe = maximo <= 2;

    flechas.forEach((flecha) => {
      const atras = Number(flecha.dataset.direccion) < 0;
      flecha.hidden = cabe;
      flecha.disabled = atras ? lista.scrollLeft <= 2 : lista.scrollLeft >= maximo - 2;
    });
  };

  const iniciar = () => {
    document.querySelectorAll('[data-pdp-carrusel][id]').forEach((lista) => {
      if (!lista.dataset.flechas) {
        lista.dataset.flechas = 'true';
        lista.addEventListener('scroll', () => actualizar(lista), { passive: true });
        if ('ResizeObserver' in window) new ResizeObserver(() => actualizar(lista)).observe(lista);
        if ('MutationObserver' in window) new MutationObserver(() => actualizar(lista)).observe(lista, { childList: true });
      }
      actualizar(lista);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
  window.addEventListener('load', iniciar);
  document.addEventListener('shopify:section:load', iniciar);
})();

/* Solicitudes de reposición para la variante agotada seleccionada (PDP y tarjetas de colección). */
(() => {
  document.addEventListener('click', event => {
    const open = event.target.closest('[data-pdp-restock-open]');
    if (open) {
      const targetId = open.getAttribute('aria-controls');
      const dialog = targetId ? document.getElementById(targetId) : null;
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
    }

    const close = event.target.closest('[data-pdp-restock-close]');
    if (close) close.closest('dialog')?.close();

    // Cerrar al hacer clic en el backdrop fuera del contenido del diálogo
    const dialog = event.target;
    if (dialog && dialog.tagName === 'DIALOG' && dialog.classList.contains('pdp-restock__dialog')) {
      const rect = dialog.getBoundingClientRect();
      const isInDialog = (
        rect.top <= event.clientY &&
        event.clientY <= rect.top + rect.height &&
        rect.left <= event.clientX &&
        event.clientX <= rect.left + rect.width
      );
      if (!isInDialog) dialog.close();
    }
  });

  // Cambio de variante en el selector del modal de reposición (tarjetas de productos con múltiples variantes)
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-pdp-restock-variant-select]');
    if (select) {
      const dialog = select.closest('dialog');
      const form = dialog?.querySelector('[data-pdp-restock-form]');
      if (form) {
        form.dataset.variant = select.value;
        const status = form.querySelector('[data-pdp-restock-status]');
        if (status) status.textContent = '';
        delete form.dataset.complete;
        const button = form.querySelector('[type="submit"]');
        if (button) button.disabled = false;
      }
    }
  });

  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-pdp-restock-form]');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.pending || form.dataset.complete || !form.reportValidity()) return;
    const button = form.querySelector('[type="submit"]');
    const status = form.querySelector('[data-pdp-restock-status]');
    const variantId = form.dataset.variant;
    form.dataset.pending = 'true'; button.disabled = true; status.textContent = '';
    try {
      const response = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(form.dataset.company)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2026-07-15' },
        body: JSON.stringify({ data: {
          type: 'back-in-stock-subscription',
          attributes: { profile: { data: { type: 'profile', attributes: { email: form.elements.namedItem('email').value.trim() } } }, channels: ['EMAIL'] },
          relationships: { variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${variantId}` } } }
        } })
      });
      if (form.dataset.variant !== variantId) return;
      if (response.status !== 202) throw new Error('restock-request-failed');
      form.dataset.complete = 'true'; status.textContent = form.dataset.success;
      if (typeof window.__olivarteEmitBisRequest === 'function') {
        window.__olivarteEmitBisRequest({ variantId: form.dataset.variant || '', source: 'pdp' });
      }
    } catch {
      if (form.dataset.variant === variantId) status.textContent = form.dataset.error;
    } finally { delete form.dataset.pending; button.disabled = !!form.dataset.complete; }
  });
})();

/* El bloque de compra se actualiza parcialmente al cambiar de variante. */
document.addEventListener('variant:change', event => {
  const owner = event.target.getAttribute?.('id');
  const variant = event.detail?.variant;

  // Actualizar fila de compra (ocultar selector de cantidad si no hay stock)
  const purchaseRow = document.querySelector('.product-purchase-row');
  const qtyBlock = purchaseRow?.querySelector('[data-block-type="quantity-selector"]');
  if (purchaseRow) {
    if (variant && variant.available === false) {
      purchaseRow.classList.add('is-sold-out');
      if (qtyBlock) {
        qtyBlock.hidden = true;
        qtyBlock.style.display = 'none';
      }
    } else if (variant && variant.available === true) {
      purchaseRow.classList.remove('is-sold-out');
      if (qtyBlock) {
        qtyBlock.hidden = false;
        qtyBlock.style.display = '';
      }
    }
  }
  // Actualizar barra de compra flotante (ocultar si no hay stock)
  const stickyBar = document.querySelector('product-sticky-bar, .product-sticky-bar');
  if (stickyBar) {
    if (variant && variant.available === false) {
      stickyBar.classList.add('is-sold-out');
      stickyBar.classList.remove('is-visible');
    } else if (variant && variant.available === true) {
      stickyBar.classList.remove('is-sold-out');
    }
  }

  document.querySelectorAll('[data-restock-owner]').forEach(block => {
    if (block.dataset.restockOwner !== owner) return;
    const form = block.querySelector('[data-pdp-restock-form]');
    const title = block.querySelector('[data-restock-product]');
    block.hidden = !variant || variant.available !== false;
    form.dataset.variant = variant?.id || '';
    delete form.dataset.complete;
    form.querySelector('[type="submit"]').disabled = !!form.dataset.pending;
    form.querySelector('[data-pdp-restock-status]').textContent = '';
    title.textContent = title.dataset.title + (title.dataset.default !== 'true' && variant ? ` · ${variant.title}` : '');
    block.querySelector('dialog')?.close();
  });
});

/* Integración y apertura del formulario oficial de Klaviyo Back in Stock (PDP y tarjetas de colección) */
(() => {
  const KLAVIYO_BIS_FORM_ID = 'SsMrzp';
  let originalUrl = null;
  let restoreInterval = null;
  let lastEmittedBisReqTime = 0;

  // Helper para capturar el contexto exacto del producto agotado
  function capturarContextoBis(el, sourceHint) {
    const path = window.location.pathname || '';
    const rawPageType = window.__olivarteContext?.page_type || '';
    const isHome = rawPageType === 'index' || path === '/' || path === '' || /^\/([a-z]{2}(-[a-z]{2})?)?\/?$/i.test(path);
    const isSearch = rawPageType === 'search' || path.includes('/search');
    const isProduct = rawPageType === 'product' || path.includes('/products/');

    let source = sourceHint || (isProduct ? 'pdp' : (isHome ? 'home_card' : (isSearch ? 'search_card' : 'collection_card')));
    let title = '';
    let variantId = '';
    let variantTitle = '';
    let price = 0;
    let brand = 'Olivarte';
    let handle = '';

    if (el) {
      const card = el.closest?.('.product-card, product-card, [data-product-card]');
      if (card) {
        title = card.querySelector('.product-title, .product-card__title, a[href*="/products/"]')?.textContent?.trim() || '';
        handle = el.dataset?.productHandle || card.querySelector('a[href*="/products/"]')?.getAttribute('href')?.split('/products/')?.[1]?.split('?')?.[0] || '';
        variantId = el.dataset?.variantId || card.querySelector('[name="id"]')?.value || '';
        const priceText = card.querySelector('.price-list, .price')?.textContent?.replace(/[^\d,.]/g, '').replace(',', '.') || '0';
        price = parseFloat(priceText) || 0;
        brand = card.querySelector('.product-vendor, .vendor')?.textContent?.trim() || 'Olivarte';
      }
    }

    if (!title && isProduct) {
      title = document.querySelector('h1.product-title, .product-info__title, h1')?.textContent?.trim() || 'Aceite de Oliva Virgen Extra';
      const priceEl = document.querySelector('.product-info .price-list, .product-info .price');
      const priceText = priceEl?.textContent?.replace(/[^\d,.]/g, '').replace(',', '.') || '0';
      price = parseFloat(priceText) || 0;
      const variantInput = document.querySelector('.product-info form [name="id"]');
      variantId = variantInput?.value || '';
      const variantTitleEl = document.querySelector('.product-info .variant-picker__selected-value, .product-info [data-selected-variant]');
      variantTitle = variantTitleEl?.textContent?.trim() || '';
      brand = document.querySelector('.product-info .product-vendor, .product-info [data-block-type="vendor"]')?.textContent?.trim() || 'Olivarte';
    }

    window.__lastBisContext = {
      title: title || 'Aceite de Oliva Virgen Extra',
      variantId: String(variantId || handle || ''),
      variantTitle: variantTitle || '',
      price: price || 0,
      brand: brand || 'Olivarte',
      handle: handle || '',
      source: source,
      timestamp: Date.now()
    };

    return window.__lastBisContext;
  }

  // Emisión al dataLayer: stock_notification_click (inicio de intención de aviso)
  function emitirStockNotificationClick(ctx) {
    try {
      window.dataLayer = window.dataLayer || [];
      const eventId = `bis_clk_${Date.now()}_${Math.floor(Math.random() * 100000)}`;
      window.dataLayer.push({
        event: 'stock_notification_click',
        event_id: eventId,
        notification_source: ctx.source || 'pdp',
        ecommerce: {
          currency: window.__olivarteContext?.currency || 'EUR',
          value: ctx.price || 0,
          items: [{
            item_id: String(ctx.variantId || ctx.handle || ''),
            item_name: ctx.title || 'Aceite de Oliva Virgen Extra',
            item_brand: ctx.brand || 'Olivarte',
            item_category: 'Aceite de Oliva Virgen Extra',
            item_variant: ctx.variantTitle || '',
            price: ctx.price || 0,
            quantity: 1
          }]
        }
      });
    } catch (e) {
      console.warn('[Analytics] Error en stock_notification_click:', e);
    }
  }

  // Emisión al dataLayer: stock_notification_request (registro completado)
  function emitirStockNotificationRequest(extra = {}) {
    try {
      // Debounce anti-duplicados de 4 segundos
      if (Date.now() - lastEmittedBisReqTime < 4000) return;
      lastEmittedBisReqTime = Date.now();

      const ctx = Object.assign({}, window.__lastBisContext || capturarContextoBis(null), extra);
      const eventId = `bis_req_${Date.now()}_${Math.floor(Math.random() * 100000)}`;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'stock_notification_request',
        event_id: eventId,
        notification_source: ctx.source || 'pdp',
        ecommerce: {
          currency: window.__olivarteContext?.currency || 'EUR',
          value: ctx.price || 0,
          items: [{
            item_id: String(ctx.variantId || ctx.handle || ''),
            item_name: ctx.title || 'Aceite de Oliva Virgen Extra',
            item_brand: ctx.brand || 'Olivarte',
            item_category: 'Aceite de Oliva Virgen Extra',
            item_variant: ctx.variantTitle || '',
            price: ctx.price || 0,
            quantity: 1
          }]
        }
      });

      console.info('[Analytics] stock_notification_request emitido con éxito:', {
        event_id: eventId,
        product: ctx.title,
        source: ctx.source
      });
    } catch (e) {
      console.warn('[Analytics] Error en stock_notification_request:', e);
    }
  }

  // Hook global para fallback
  window.__olivarteEmitBisRequest = emitirStockNotificationRequest;

  // Escuchar el evento nativo de envío de formularios de Klaviyo
  window.addEventListener('klaviyoForms', (event) => {
    try {
      const detail = event.detail;
      if (!detail) return;
      if (detail.type === 'submit' || detail.type === 'stepSubmit') {
        const isBisForm = detail.formId === KLAVIYO_BIS_FORM_ID;
        const hasRecentBisContext = window.__lastBisContext && (Date.now() - window.__lastBisContext.timestamp < 600000);
        if (isBisForm || hasRecentBisContext) {
          emitirStockNotificationRequest();
        }
      }
    } catch (_) {}
  });

  function restoreOriginalUrl() {
    if (originalUrl) {
      if (window.location.href !== originalUrl) {
        history.replaceState(null, '', originalUrl);
      }
      originalUrl = null;
    }
    if (restoreInterval) {
      clearInterval(restoreInterval);
      restoreInterval = null;
    }
  }

  function openKlaviyoBisModal(handle, variantId, triggerEl) {
    const ctx = capturarContextoBis(triggerEl);
    emitirStockNotificationClick(ctx);

   if (handle && variantId && !window.location.pathname.includes('/products/' + handle)) {
      originalUrl = window.location.href;
      history.replaceState({ klaviyoBisCard: true, originalUrl }, '', `/products/${handle}?variant=${variantId}`);
    }

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', KLAVIYO_BIS_FORM_ID]);

    if (originalUrl) {
      if (restoreInterval) clearInterval(restoreInterval);
      // Comenzar a vigilar cuando se cierre el modal para devolver la URL original
      setTimeout(() => {
        restoreInterval = setInterval(() => {
          const modal = document.querySelector(`[data-testid="klaviyo-form-${KLAVIYO_BIS_FORM_ID}"]`);
          if (!modal) {
            restoreOriginalUrl();
          }
        }, 300);
      }, 500);
    }
  }

  // Cerrar / restaurar URL al interactuar con el cierre de Klaviyo o backdrop
  document.addEventListener('click', event => {
    if (originalUrl && event.target.closest('.klaviyo-close-form, [aria-label="Close dialog"]')) {
      setTimeout(restoreOriginalUrl, 100);
    }
  });

  document.addEventListener('keydown', event => {
    if (originalUrl && event.key === 'Escape') {
      setTimeout(restoreOriginalUrl, 100);
    }
  });

  window.addEventListener('popstate', event => {
    if (event.state && event.state.originalUrl) {
      restoreOriginalUrl();
    }
  });

  // Delegación de clics en tarjetas de producto (colecciones, búsqueda, carruseles)
  document.addEventListener('click', event => {
    const cardTrigger = event.target.closest('[data-klaviyo-bis-trigger], .product-card__quick-add-button--sold-out');
    if (cardTrigger) {
      event.preventDefault();
      event.stopPropagation();
      const handle = cardTrigger.dataset.productHandle;
      const variantId = cardTrigger.dataset.variantId;
      openKlaviyoBisModal(handle, variantId, cardTrigger);
    }
  });

  function syncKlaviyoBis() {
    const bisContainer = document.getElementById('klaviyo-bis-button-container');
    const mainBuyButtons = document.querySelector('.product-info buy-buttons');
    const placeholder = document.querySelector('.pdp-restock-placeholder');

    if (bisContainer && mainBuyButtons) {
      if (!mainBuyButtons.contains(bisContainer)) {
        mainBuyButtons.appendChild(bisContainer);
      }
      mainBuyButtons.classList.add('has-klaviyo-bis');
    }

    if (placeholder) {
      const isBisVisible = bisContainer && window.getComputedStyle(bisContainer).display !== 'none';
      if (isBisVisible) {
        placeholder.style.display = 'none';
      } else {
        const isSoldOut = document.querySelector('.product-purchase-row.is-sold-out, .product-sold-out');
        placeholder.style.display = isSoldOut ? '' : 'none';
      }
    }
  }

  // Observar inyecciones asíncronas de Klaviyo solo en PDP si existe placeholder o botones de compra
  const targetKlaviyo = document.querySelector('.product-info, .pdp-restock-placeholder');
  if (targetKlaviyo) {
    if ('MutationObserver' in window) {
      const bisObserver = new MutationObserver(() => {
        syncKlaviyoBis();
      });
      bisObserver.observe(targetKlaviyo, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncKlaviyoBis);
    } else {
      syncKlaviyoBis();
    }
  }

  document.addEventListener('variant:change', () => {
    setTimeout(syncKlaviyoBis, 50);
    setTimeout(syncKlaviyoBis, 300);
    setTimeout(syncKlaviyoBis, 800);
  });

  // Delegación de clics: si se pulsa el placeholder o el botón de la barra móvil cuando está agotado
  document.addEventListener('click', event => {
    const placeholder = event.target.closest('.pdp-restock-placeholder');
    const stickyAtc = event.target.closest('.sticky-mobile-atc, .product-sticky-bar__mobile');
    const isSoldOut = document.querySelector('.product-purchase-row.is-sold-out, .product-sold-out');

    if (placeholder || (stickyAtc && isSoldOut && (stickyAtc.querySelector('.button--disabled') || stickyAtc.querySelector('[disabled]')))) {
      if (placeholder) event.preventDefault();

      const trigger = placeholder || stickyAtc;
      const ctx = capturarContextoBis(trigger, 'pdp');
      emitirStockNotificationClick(ctx);

      const klaviyoBtn = document.querySelector('#klaviyo-bis-button-container button, #klaviyo-bis-button-container a');
      if (klaviyoBtn) {
        klaviyoBtn.click();
      } else {
        openKlaviyoBisModal(null, null, trigger);
      }
    } else {
      // También capturar si el usuario pulsa directamente el botón inyectado por Klaviyo
      const klaviyoContainerBtn = event.target.closest('#klaviyo-bis-button-container button, #klaviyo-bis-button-container a');
      if (klaviyoContainerBtn) {
        const ctx = capturarContextoBis(klaviyoContainerBtn, 'pdp');
        emitirStockNotificationClick(ctx);
     }
    }
  });
})();

/*
 * Sincronización y control de visibilidad de las flechas del carrusel de fotos (PDP).
 * Deshabilita y oculta la flecha izquierda en la primera foto y la flecha derecha en la
 * última foto (con tolerancia para subpíxeles en pantallas móviles).
 */
(() => {
  const syncGalleryArrows = () => {
    const gallery = document.querySelector('.product-gallery');
    if (!gallery) return;

    const carousel = gallery.querySelector('.product-gallery__carousel');
    const prevBtn = gallery.querySelector('carousel-prev-button button');
    const nextBtn = gallery.querySelector('carousel-next-button button');
    if (!carousel || (!prevBtn && !nextBtn)) return;

    const update = () => {
      const visibleCells = Array.from(carousel.children).filter(
        (el) => el.classList.contains('product-gallery__media') && !el.hasAttribute('hidden')
      );
      const total = visibleCells.length;
      if (total <= 1) {
        if (prevBtn) prevBtn.disabled = true;
        if (nextBtn) nextBtn.disabled = true;
        return;
      }

      const scrollLeft = Math.round(Math.abs(carousel.scrollLeft));
      const maxScroll = Math.max(0, carousel.scrollWidth - carousel.clientWidth);
      const isStart = scrollLeft <= 8;
      const isEnd = scrollLeft >= maxScroll - 8;

      if (prevBtn) prevBtn.disabled = isStart;
      if (nextBtn) nextBtn.disabled = isEnd;
    };

    update();
    carousel.addEventListener('scroll', update, { passive: true });
    carousel.addEventListener('carousel:change', update);
    carousel.addEventListener('carousel:settle', update);
    carousel.addEventListener('carousel:filter', update);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncGalleryArrows);
  } else {
    syncGalleryArrows();
  }

  window.addEventListener('load', syncGalleryArrows);
  document.addEventListener('variant:change', () => setTimeout(syncGalleryArrows, 150));
  document.addEventListener('shopify:section:load', syncGalleryArrows);
})();

/*
 * Vídeo de producto en la galería (PDP).
 * Se asegura de que el vídeo sea visible y se reproduzca al pasar de foto en foto
 * (tanto al deslizar con el dedo como al usar las flechas del carrusel).
 */
(() => {
  const syncGalleryVideos = () => {
    const gallery = document.querySelector('.product-gallery');
    if (!gallery) return;

    const carousel = gallery.querySelector('.product-gallery__carousel');
    const videos = gallery.querySelectorAll('video-media');
    if (!carousel || !videos.length) return;

    const handleVideoInView = () => {
      const carouselRect = carousel.getBoundingClientRect();
      const carouselCenter = carouselRect.left + carouselRect.width / 2;

      videos.forEach((videoMedia) => {
        const slide = videoMedia.closest('.product-gallery__media');
        if (!slide || slide.hasAttribute('hidden')) return;

        const slideRect = slide.getBoundingClientRect();
        const isCurrentSlide = slideRect.left < carouselCenter && slideRect.right > carouselCenter;

        if (isCurrentSlide) {
          // Marcar como cargado para que el elemento <video> no quede en opacity: 0
          videoMedia.setAttribute('loaded', '');
          const videoElement = videoMedia.querySelector('video');
          if (videoElement) {
            videoElement.setAttribute('preload', 'metadata');
            if (videoMedia.hasAttribute('autoplay') || gallery.hasAttribute('autoplay-media')) {
              videoElement.muted = true;
              videoElement.play().catch(() => {});
            }
          }
        } else {
          const videoElement = videoMedia.querySelector('video');
          if (videoElement && !videoElement.paused) {
            videoElement.pause();
          }
        }
      });
    };

    handleVideoInView();
    carousel.addEventListener('scroll', () => requestAnimationFrame(handleVideoInView), { passive: true });
    carousel.addEventListener('carousel:change', handleVideoInView);
    carousel.addEventListener('carousel:settle', handleVideoInView);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncGalleryVideos);
  } else {
    syncGalleryVideos();
  }

  window.addEventListener('load', syncGalleryVideos);
  document.addEventListener('variant:change', () => setTimeout(syncGalleryVideos, 200));
  document.addEventListener('shopify:section:load', syncGalleryVideos);
})();

/*
 * Franja de garantías de la ficha en móvil: carrusel centrado en el que asoman la tarjeta
 * anterior y la siguiente, más transparentes (como la referencia de Matcha & Co). Pasa sola
 * cada 2,4 s mientras está en pantalla; al tocarla se para unos segundos. En escritorio no
 * hace nada: ahí se ven las 4 a la vez. Respeta "reducir movimiento".
 */
(() => {
  const SELECTOR = '.shopify-section[id$="__iconos_ficha"] .text-with-icons--stacked';
  const INTERVALO = 2400;
  const PAUSA_TRAS_TOQUE = 6000;
  const movil = window.matchMedia('(max-width: 699px)');
  const menosMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)');

  const iniciar = () => {
    document.querySelectorAll(SELECTOR).forEach((lista) => {
      if (lista.dataset.carrusel) return;
      const items = [...lista.querySelectorAll('.text-with-icons__item')];
      if (items.length < 2) return;
      lista.dataset.carrusel = 'true';

      let actual = 0;
      let visible = false;
      let pausadoHasta = 0;

      const marcar = () => {
        const centro = lista.scrollLeft + lista.clientWidth / 2;
        let mejor = 0;
        let distancia = Infinity;
        items.forEach((item, indice) => {
          const d = Math.abs(item.offsetLeft + item.offsetWidth / 2 - centro);
          if (d < distancia) { distancia = d; mejor = indice; }
        });
        actual = mejor;
        items.forEach((item, indice) => item.classList.toggle('is-centro', indice === mejor));
      };

      const ir = (indice, instantaneo = false) => {
        const item = items[indice];
        lista.scrollTo({
          left: item.offsetLeft - (lista.clientWidth - item.offsetWidth) / 2,
          behavior: instantaneo || menosMovimiento.matches ? 'auto' : 'smooth',
        });
      };

      lista.addEventListener('scroll', () => requestAnimationFrame(marcar), { passive: true });
      const pausar = () => { pausadoHasta = Date.now() + PAUSA_TRAS_TOQUE; };
      lista.addEventListener('pointerdown', pausar, { passive: true });
      lista.addEventListener('touchstart', pausar, { passive: true });

      // Empieza en la segunda para que ya asomen las dos de los lados. Se repite al terminar de
      // cargar la página, cuando ya están las fuentes y los anchos definitivos.
      if (movil.matches) ir(1, true);
      marcar();
      window.addEventListener('load', () => { if (movil.matches) { ir(1, true); marcar(); } }, { once: true });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([entrada]) => { visible = entrada.isIntersecting; }, { threshold: 0.5 }).observe(lista);
      } else {
        visible = true;
      }

      setInterval(() => {
        if (!movil.matches || menosMovimiento.matches || !visible || document.hidden) return;
        if (Date.now() < pausadoHasta) return;
        ir((actual + 1) % items.length);
      }, INTERVALO);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
  window.addEventListener('load', iniciar);
  document.addEventListener('shopify:section:load', iniciar);
})();

/*
 * Estrellas del resumen: al pulsarlas se baja a la sección de opiniones (Olivarte, 23/09).
 * El distintivo lo pinta Judge.me cuando le llega su script, así que se escucha en el
 * documento en lugar de en el elemento. Si el producto no tiene opiniones no hay sección
 * a la que ir y no se toca nada.
 */
(() => {
  const DISTINTIVO = '.jdgm-preview-badge';
  const OPINIONES = '[data-pdp-reviews]';

  const irAOpiniones = () => {
    const destino = document.querySelector(OPINIONES);
    if (!destino) return false;
    // El tema ya reserva el alto de la cabecera fija con scroll-padding-block-start
    destino.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return true;
  };

  document.addEventListener('click', (evento) => {
    const distintivo = evento.target.closest(DISTINTIVO);
    if (!distintivo || !distintivo.closest('.product-info, .product-information')) return;
    if (!document.querySelector(OPINIONES)) return;
    evento.preventDefault();
    evento.stopPropagation();
    irAOpiniones();
  }, true);

  document.addEventListener('keydown', (evento) => {
    if (evento.key !== 'Enter' && evento.key !== ' ') return;
    const distintivo = evento.target.closest?.(DISTINTIVO);
    if (!distintivo || !distintivo.closest('.product-info, .product-information')) return;
    if (!irAOpiniones()) return;
    evento.preventDefault();
  });

  // Marca el distintivo para que se vea que es pulsable en cuanto Judge.me lo pinta
  const marcar = () => {
    if (!document.querySelector(OPINIONES)) return;
    document.querySelectorAll(DISTINTIVO).forEach((distintivo) => {
      if (!distintivo.closest('.product-info, .product-information')) return;
      if (distintivo.dataset.irAOpiniones) return;
      distintivo.dataset.irAOpiniones = 'true';
      distintivo.setAttribute('role', 'link');
      distintivo.setAttribute('tabindex', '0');
    });
  };

  const productInfoEl = document.querySelector('.product-info, .product-information');
  if (productInfoEl) {
    marcar();
    if ('MutationObserver' in window && !document.querySelector(`${DISTINTIVO}[data-ir-a-opiniones]`)) {
      // Solo hasta que Judge.me pinte el distintivo: después el observador sobra y se desconecta
      const observador = new MutationObserver(() => {
        marcar();
        if (document.querySelector(`${DISTINTIVO}[data-ir-a-opiniones]`)) observador.disconnect();
      });
      observador.observe(productInfoEl, { childList: true, subtree: true });
      setTimeout(() => observador.disconnect(), 10000);
    }
    document.addEventListener('variant:change', () => setTimeout(marcar, 300));
  }
})();
/* ==========================================================================
 * SISTEMA DE ANALÍTICA — OLIVARTE
 * ========================================================================== */
(() => {
  window.dataLayer = window.dataLayer || [];

  // Helper para generar event_id único compatible con deduplicación Meta CAPI & Google Ads
  const generarEventId = (prefijo = 'evt') => {
    return `${prefijo}_${Date.now()}_${Math.floor(Math.random() * 1000000)}`;
  };

  // Helper de persistencia de cookies First-Party
  const setCookie = (nombre, valor, dias = 90) => {
    try {
      const fecha = new Date();
      fecha.setTime(fecha.getTime() + dias * 24 * 60 * 60 * 1000);
      document.cookie = `${nombre}=${encodeURIComponent(valor)};expires=${fecha.toUTCString()};path=/;SameSite=Lax`;
    } catch (_) {}
  };

  const getCookie = (nombre) => {
    try {
      const v = document.cookie.match('(^|;) ?' + nombre + '=([^;]*)(;|$)');
      return v ? decodeURIComponent(v[2]) : null;
    } catch (_) {
      return null;
    }
  };

  // 1. CAPTURA Y PERSISTENCIA DE ATRIBUCIÓN FIRST-PARTY (UTMs, GCLID, FBCLID)
  const capturarAtribucion = () => {
    try {
      const params = new URLSearchParams(window.location.search);
      const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid'];

      utmKeys.forEach((key) => {
        if (params.has(key)) {
          const val = params.get(key);
          // Guardar Last-Touch
          try {
            localStorage.setItem(`olivarte_last_${key}`, val);
          } catch (_) {}
          setCookie(`olivarte_last_${key}`, val);

          // Guardar First-Touch solo si no existía antes
          try {
            if (!localStorage.getItem(`olivarte_first_${key}`)) {
              localStorage.setItem(`olivarte_first_${key}`, val);
              setCookie(`olivarte_first_${key}`, val);
            }
          } catch (_) {}
        }
      });

      // Capturar fbp y fbc para Meta CAPI
      if (params.has('fbclid')) {
        const fbclid = params.get('fbclid');
        const fbc = `fb.1.${Date.now()}.${fbclid}`;
        setCookie('_fbc', fbc, 90);
        try { localStorage.setItem('olivarte_fbc', fbc); } catch (_) {}
      }
      if (!getCookie('_fbp')) {
        const fbp = `fb.1.${Date.now()}.${Math.floor(Math.random() * 1000000000)}`;
        setCookie('_fbp', fbp, 90);
        try { localStorage.setItem('olivarte_fbp', fbp); } catch (_) {}
      }
    } catch (e) {
      console.warn('[Analytics] Error capturando atribución:', e);
    }
  };

  capturarAtribucion();

  // Helper: Determinar ID y Nombre de lista según ubicación del elemento (Home, PDP Recomendados, Colección, Búsqueda)
  const determinarContextoLista = (card) => {
    try {
      // A. Recomendaciones / Relacionados en PDP
      const recs = card.closest('product-recommendations, .related-products, [class*="related-products"]');
      if (recs) {
        const heading = recs.querySelector('h2, .section-header__title, .h2, [class*="heading"]')?.textContent?.trim() || 'Productos recomendados';
        return {
          listId: 'pdp_recommended_products',
          listName: 'Ficha de producto — ' + heading
        };
      }

      // B. Complementarios en PDP
      const comp = card.closest('.complementary-products, [class*="complementary"]');
      if (comp) {
        const heading = comp.querySelector('.h5, h2, h3, [class*="header"]')?.textContent?.trim() || 'Productos complementarios';
        return {
          listId: 'pdp_complementary_products',
          listName: 'Ficha de producto — ' + heading
        };
      }

      // C. Vistos recientemente
      const recent = card.closest('recently-viewed-products, [class*="recently-viewed"]');
      if (recent) {
        const heading = recent.querySelector('h2, .section-header__title, .h2')?.textContent?.trim() || 'Vistos recientemente';
        return {
          listId: 'recently_viewed_products',
          listName: heading
        };
      }

      // D. Página de Inicio (Home): Colecciones destacadas / Carousels
      const isHome = window.location.pathname === '/' || window.__olivarteContext?.page_type === 'index';
      if (isHome) {
        const sectionEl = card.closest('section, .shopify-section, featured-collections-carousel, [class*="featured-collections"]') || card.parentElement;
        
        let heading = '';
        const carouselItem = card.closest('.featured-collections-carousel__item');
        if (carouselItem && sectionEl) {
          const carousel = carouselItem.parentElement;
          const itemIndex = Array.from(carousel?.children || []).indexOf(carouselItem);
          const navButtons = sectionEl.querySelectorAll('carousel-navigation button, .featured-collections-navigation button');
          if (itemIndex >= 0 && navButtons && navButtons[itemIndex]) {
            heading = navButtons[itemIndex].textContent.trim();
          }
        }

        if (!heading) {
          const activeTab = sectionEl?.querySelector('carousel-navigation button[aria-current="true"], .featured-collections-navigation button[aria-current="true"]');
          heading = activeTab?.textContent?.trim() || sectionEl?.querySelector('h2, .section-header__title, .h2')?.textContent?.trim() || 'Colección destacada';
        }

        const cleanId = heading.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
        return {
          listId: 'home_' + (cleanId || 'featured'),
          listName: 'Home — ' + heading
        };
      }

      // E. Página de Colección
      if (window.__olivarteCollection?.handle) {
        return {
          listId: window.__olivarteCollection.handle,
          listName: window.__olivarteCollection.title || 'Catálogo'
        };
      }

      // F. Página de Búsqueda
      if (window.location.pathname.includes('/search') || window.__olivarteContext?.page_type === 'search') {
        const q = new URLSearchParams(window.location.search).get('q') || document.querySelector('input[name="q"]')?.value || '';
        return {
          listId: 'search_results',
          listName: 'Búsqueda' + (q ? ' — ' + q : '')
        };
      }

      // G. Fallback general: Cabecera de sección más próxima
      const parentSection = card.closest('section, .shopify-section');
      const sectionTitle = parentSection?.querySelector('h2, .h2, .section-header__title')?.textContent?.trim();
      if (sectionTitle) {
        const cleanId = sectionTitle.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
        return {
          listId: 'list_' + cleanId,
          listName: sectionTitle
        };
      }
    } catch (_) {}

    return {
      listId: 'catalog_grid',
      listName: 'Catálogo'
    };
  };

  // 2. MEDICIÓN VIEWPORT IMPRESSIONS PARA VIEW_ITEM_LIST (HOME, COLECCIONES Y RECOMENDADOS)
  const iniciarImpresionesViewportList = () => {
    if (!('IntersectionObserver' in window)) return;

    const productsMap = window.__olivarteCollectionProducts || {};
    const pendingBatches = new Map(); // key: listId -> { listId, listName, items: [] }
    let batchTimer = null;
    const reportedKeys = new Set(); // key: `${listId}:${handle}`
    const listIndexCounter = new Map(); // key: listId -> count of items seen

    const dispatchBatches = () => {
      if (pendingBatches.size === 0) return;

      pendingBatches.forEach((batch) => {
        if (!batch.items || batch.items.length === 0) return;

        const currentSort = new URLSearchParams(window.location.search).get('sort_by') || document.querySelector('select[name="sort_by"]')?.value || '';
        const payload = {
          event: 'view_item_list',
          event_id: generarEventId('vil'),
          ecommerce: {
            item_list_id: batch.listId,
            item_list_name: batch.listName,
            items: batch.items
          }
        };
        if (currentSort) {
          payload.sort_by = currentSort;
        }

        window.dataLayer.push(payload);
      });

      pendingBatches.clear();
    };

    const cardObserver = new IntersectionObserver((entries) => {
      let newlyVisible = false;

      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const card = entry.target;
        const handle = card.getAttribute('handle') || card.dataset.productHandle || card.querySelector('a[href*="/products/"]')?.getAttribute('href')?.split('/products/')[1]?.split('?')[0] || '';
        if (!handle) return;

        const { listId, listName } = determinarContextoLista(card);
        const reportKey = `${listId}:${handle}`;

        if (reportedKeys.has(reportKey)) return;

        reportedKeys.add(reportKey);
        cardObserver.unobserve(card);

        // Incrementar índice de posición para esta lista concreta
        const currentIndex = (listIndexCounter.get(listId) || 0) + 1;
        listIndexCounter.set(listId, currentIndex);

        // Extraer datos del producto (prioridad: data attributes > diccionario > DOM)
        const dictData = productsMap[handle] || {};
        const title = card.dataset.productTitle || dictData.name || card.querySelector('.product-card__title, .product-title, h3, h2')?.textContent?.trim() || handle;
        const brand = card.dataset.productBrand || dictData.brand || card.querySelector('.vendor, [class*="vendor"]')?.textContent?.trim() || 'Olivarte';
        const price = card.dataset.productPrice ? parseFloat(card.dataset.productPrice) : (dictData.price || 0);
        const variant = card.dataset.productVariant || dictData.variant || '';
        const itemId = card.dataset.productId || dictData.id || handle;

        if (!pendingBatches.has(listId)) {
          pendingBatches.set(listId, {
            listId: listId,
            listName: listName,
            items: []
          });
        }

        pendingBatches.get(listId).items.push({
          item_id: String(itemId),
          item_name: title,
          item_brand: brand,
          item_category: 'Aceite de Oliva Virgen Extra',
          item_variant: variant,
          price: Number(price),
          item_list_id: listId,
          item_list_name: listName,
          index: currentIndex
        });

        newlyVisible = true;
      });

      if (newlyVisible) {
        clearTimeout(batchTimer);
        batchTimer = setTimeout(dispatchBatches, 600);
      }
    }, {
      root: null,
      threshold: 0.25
    });

    const observeAllCards = () => {
      const cards = document.querySelectorAll('product-card, .product-card, [data-product-card], .horizontal-product-card');
      cards.forEach((c) => {
        const handle = c.getAttribute('handle') || c.dataset.productHandle || c.querySelector('a[href*="/products/"]')?.getAttribute('href')?.split('/products/')[1]?.split('?')[0];
        if (handle) {
          const { listId } = determinarContextoLista(c);
          if (!reportedKeys.has(`${listId}:${handle}`)) {
            cardObserver.observe(c);
          }
        }
      });
    };

    observeAllCards();

    // Observar elementos dinámicos (scroll infinito, filtros AJAX, o carga diferida de recomendaciones)
    let mutationDebounce = null;
    const domObserver = new MutationObserver(() => {
      clearTimeout(mutationDebounce);
      mutationDebounce = setTimeout(observeAllCards, 250);
    });

    const targetListContainer = document.getElementById('main') || document.body;
    domObserver.observe(targetListContainer, { childList: true, subtree: true });

    window.addEventListener('beforeunload', dispatchBatches);
  };

  const scheduleInit = () => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(iniciarImpresionesViewportList, { timeout: 1500 });
    } else {
      setTimeout(iniciarImpresionesViewportList, 300);
    }
  };

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    scheduleInit();
  } else {
    document.addEventListener('DOMContentLoaded', scheduleInit);
  }

  // 3. CAMBIO DINÁMICO DE VARIANTE EN PDP (VIEW_ITEM REACTIVO)
  document.addEventListener('variant:change', (event) => {
    try {
      const variant = event.detail?.variant;
      const prod = window.__olivarteProduct;
      if (!variant || !prod) return;

      const currency = window.__olivarteContext?.currency || 'EUR';
      const eventId = generarEventId('vi');

      window.dataLayer.push({
        event: 'view_item',
        event_id: eventId,
        ecommerce: {
          currency: currency,
          value: variant.price / 100.0,
          items: [{
            item_id: variant.sku || String(variant.id),
            item_name: prod.title,
            item_brand: prod.vendor,
            item_category: 'Aceite de Oliva Virgen Extra',
            item_category2: prod.variedad || '',
            item_category3: prod.cosecha || '',
            item_variant: variant.title,
            price: variant.price / 100.0,
            quantity: 1
          }]
        }
      });
    } catch (e) {
      console.warn('[Analytics] Error en view_item dinámico:', e);
    }
  });

  // Tracker de origen del clic de compra para identificar ubicación exacta
  let ultimoElementoAtc = null;

  document.addEventListener('click', (event) => {
    const atcBtn = event.target.closest('button[type="submit"], button[name="add"], .product-card__quick-add-button, .upsell-card__circle-add-btn, [data-action="add-to-cart"], [data-atc-source]');
    if (atcBtn) {
      ultimoElementoAtc = atcBtn;
    }
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (form) {
      ultimoElementoAtc = event.submitter || form.querySelector('button[type="submit"], button[name="add"]') || form;
    }
  }, true);

  const determinarOrigenAtc = (triggerEl, formEl) => {
    const el = triggerEl || formEl;
    const form = formEl || triggerEl?.closest?.('form');
    const path = window.location.pathname || '';
    const rawPageType = window.__olivarteContext?.page_type || '';

    // Detección contextual exhaustiva de página (Home, Búsqueda, Colección, Ficha de Producto)
    const isHome = rawPageType === 'index' ||
                   path === '/' ||
                   path === '' ||
                   /^\/([a-z]{2}(-[a-z]{2})?)?\/?$/i.test(path);

    const isSearch = rawPageType === 'search' || path.includes('/search');
    const isProduct = rawPageType === 'product' || path.includes('/products/');
    const isCollection = !isHome && (rawPageType === 'collection' || path.includes('/collections/'));

    // 1. Carrito Drawer / Venta Cruzada (Upselling) - Máxima prioridad sobre la página de fondo
    if (
      el?.closest?.('upselling-cart-drawer, .upsell-card, .cart-drawer__complementary-products, cart-drawer, [data-source="cart_upsell"]') ||
      form?.closest?.('upselling-cart-drawer, .upsell-card, cart-drawer') ||
      el?.getAttribute?.('data-atc-source') === 'cart_upsell_drawer' ||
      form?.querySelector?.('input[name="properties[_Source]"]')?.value?.toLowerCase()?.includes('upsell')
    ) {
      return 'cart_upsell_drawer';
    }

    // 2. Barra fija flotante de PDP (Sticky Bar)
    if (
      el?.closest?.('product-sticky-bar, .product-sticky-bar, [data-sticky-bar]') ||
      form?.closest?.('product-sticky-bar, .product-sticky-bar') ||
      el?.getAttribute?.('data-atc-source') === 'pdp_sticky_bar'
    ) {
      return 'pdp_sticky_bar';
    }

    // 3. Productos Complementarios en PDP
    if (
      el?.closest?.('.complementary-products, [class*="complementary"]') ||
      form?.closest?.('.complementary-products') ||
      el?.getAttribute?.('data-atc-source') === 'pdp_complementary' ||
      form?.querySelector?.('input[name="properties[_Source]"]')?.value === 'pdp_complementary'
    ) {
      return 'pdp_complementary';
    }

    // 4. Modal de compra rápida (Quick Buy Modal)
    const quickBuyModal = el?.closest?.('quick-buy-modal, .quick-buy-modal') || form?.closest?.('quick-buy-modal, .quick-buy-modal');
    if (quickBuyModal) {
      const modalSource = quickBuyModal.getAttribute('data-atc-source');
      if (modalSource) {
        if (modalSource === 'plp_quick_add' && isHome) return 'home_quick_add';
        if (modalSource === 'plp_quick_add' && isSearch) return 'search_quick_add';
        return modalSource;
      }
      if (isProduct && quickBuyModal.closest('product-recommendations, .related-products')) return 'pdp_recommendations';
      if (isProduct) return 'pdp_recommendations';
      if (isHome) return 'home_quick_add';
      if (isSearch) return 'search_quick_add';
      return 'plp_quick_add';
    }

    // 5. Recomendaciones / Relacionados en PDP
    if (
      (isProduct && (
        el?.closest?.('product-recommendations, .related-products, [class*="related-products"]') ||
        form?.closest?.('product-recommendations, .related-products')
      )) ||
      el?.getAttribute?.('data-atc-source') === 'pdp_recommendations' ||
      form?.querySelector?.('input[name="properties[_Source]"]')?.value === 'pdp_recommendations'
    ) {
      return 'pdp_recommendations';
    }

    // 6. Tarjeta de producto directa en rejilla (product-card / grid)
    if (
      el?.closest?.('.product-card, product-card, [data-product-card], .horizontal-product-card, .product-card__quick-add-button') ||
      form?.closest?.('.product-card, product-card, [data-product-card], .horizontal-product-card')
    ) {
      if (isProduct) return 'pdp_recommendations';
      if (isHome) return 'home_quick_add';
      if (isSearch) return 'search_quick_add';
      return 'plp_quick_add';
    }

    // 7. Lista de pedido rápido B2B (Quick Order List)
    if (el?.closest?.('.quick-order-list') || form?.closest?.('.quick-order-list')) {
      return 'quick_order_list';
    }

    // 8. Entrada directa por propiedad o atributo data-atc-source (con validación de contexto de página)
    const explicitSource = el?.getAttribute?.('data-atc-source') || form?.querySelector?.('input[name="properties[_Source]"]')?.value;
    if (explicitSource) {
      if (explicitSource === 'plp_quick_add' && isHome) return 'home_quick_add';
      if (explicitSource === 'plp_quick_add' && isSearch) return 'search_quick_add';
      if (explicitSource === 'plp_quick_add' && isProduct) return 'pdp_recommendations';
      return explicitSource;
    }

    // 9. En páginas de Home o Búsqueda NUNCA puede ser plp_quick_add ni pdp_main_button
    if (isHome) {
      return 'home_quick_add';
    }
    if (isSearch) {
      return 'search_quick_add';
    }

    // 10. Botón principal de la Ficha de Producto (PDP)
    if (
      isProduct &&
      (el?.closest?.('.product-info, .product-information, buy-buttons, [id*="main-product"]') ||
       form?.closest?.('.product-info, .product-information, buy-buttons, [id*="main-product"]'))
    ) {
      return 'pdp_main_button';
    }

    // 11. Fallback final según contexto
    if (isProduct) return 'pdp_main_button';
    if (isCollection) return 'plp_quick_add';
    return isHome ? 'home_quick_add' : (isSearch ? 'search_quick_add' : 'plp_quick_add');
  };


  // 4. AÑADIR AL CARRITO (ADD_TO_CART) CON DISCRIMINACIÓN DE ORIGEN (PDP / PLP / UPSELLING)
  document.addEventListener('variant:add', (event) => {
    try {
      const items = event.detail?.items;
      if (!items || !items.length) return;

      const currency = window.__olivarteContext?.currency || 'EUR';
      const eventId = generarEventId('a2c');
      let totalValue = 0;

      // Determinar origen exacto analizando también el formulario o elemento disparador
      const form = event.target?.closest?.('form') || event.target;

      const origen = determinarOrigenAtc(ultimoElementoAtc, form);
      ultimoElementoAtc = null; // Reset para el siguiente clic

      const ecommerceItems = items.map((item) => {
        const itemPrice = (item.final_price || item.price || 0) / 100.0;
        const qty = item.quantity || 1;
        totalValue += itemPrice * qty;

        return {
          item_id: item.sku || String(item.variant_id || item.id),
          item_name: item.product_title || item.title,
          item_brand: item.vendor || 'Olivarte',
          item_category: 'Aceite de Oliva Virgen Extra',
          item_variant: item.variant_title || '',
          item_list_name: origen, // Nombre de lista según ubicación exacta
          price: itemPrice,
          quantity: qty
        };
      });

      window.dataLayer.push({
        event: 'add_to_cart',
        event_id: eventId,
        add_to_cart_source: origen, // 'pdp_main_button' | 'pdp_sticky_bar' | 'plp_quick_add' | 'cart_upsell_drawer'
        ecommerce: {
          currency: currency,
          value: Math.round(totalValue * 100) / 100,
          items: ecommerceItems
        }
      });

      // Si procede de la venta cruzada (Upselling), emitir evento dedicado de conversión de upsell
      if (origen === 'cart_upsell_drawer') {
        window.dataLayer.push({
          event: 'upsell_conversion',
          event_id: generarEventId('upconv'),
          upsell_placement: 'cart_drawer',
          ecommerce: {
            currency: currency,
            value: Math.round(totalValue * 100) / 100,
            items: ecommerceItems
          }
        });
      }
    } catch (e) {
      console.warn('[Analytics] Error en add_to_cart:', e);
    }
  });

  // 5. GESTIÓN DEL CARRITO: VACIADO / REDUCCIÓN (REMOVE_FROM_CART) Y VIEW_CART
  let prevCartItems = [];
  if (window.__olivarteCart?.items) {
    try {
      prevCartItems = JSON.parse(JSON.stringify(window.__olivarteCart.items));
    } catch (_) {}
  }

  document.documentElement.addEventListener('cart:change', (event) => {
    try {
      const newCart = event.detail?.cart;
      if (!newCart || !newCart.items) return;

      const currency = newCart.currency || 'EUR';

      // Detectar reducciones de cantidad o eliminaciones
      prevCartItems.forEach((prevItem) => {
        const found = newCart.items.find((i) => i.id === prevItem.id || i.key === prevItem.key);
        const prevQty = prevItem.quantity || 1;
        const newQty = found ? found.quantity : 0;

        if (newQty < prevQty) {
          const removedQty = prevQty - newQty;
          const itemPrice = (prevItem.price || 0) / 100.0;
          const eventId = generarEventId('rfc');

          window.dataLayer.push({
            event: 'remove_from_cart',
            event_id: eventId,
            ecommerce: {
              currency: currency,
              value: Math.round(itemPrice * removedQty * 100) / 100,
              items: [{
                item_id: prevItem.sku || String(prevItem.variant_id || prevItem.id),
                item_name: prevItem.product_title || prevItem.title,
                item_brand: prevItem.vendor || 'Olivarte',
                item_category: 'Aceite de Oliva Virgen Extra',
                item_variant: prevItem.variant_title || '',
                price: itemPrice,
                quantity: removedQty
              }]
            }
          });
        }
      });

      prevCartItems = JSON.parse(JSON.stringify(newCart.items));
    } catch (e) {
      console.warn('[Analytics] Error en remove_from_cart:', e);
    }
  });

  // Detección de apertura de Cart Drawer para disparar view_cart
  const cartDrawerEl = document.getElementById('cart-drawer');
  let cartDrawerAbierto = false;
  if (cartDrawerEl && 'MutationObserver' in window) {
    const drawerObserver = new MutationObserver(() => {
      const isOpen = cartDrawerEl.hasAttribute('open') || cartDrawerEl.getAttribute('aria-hidden') === 'false';
      if (isOpen && !cartDrawerAbierto) {
        cartDrawerAbierto = true;
        dispararViewCart();
      } else if (!isOpen) {
        cartDrawerAbierto = false;
      }
    });
    drawerObserver.observe(cartDrawerEl, { attributes: true, attributeFilter: ['open', 'aria-hidden'] });
  }

  const dispararViewCart = () => {
    try {
      fetch(`${Shopify.routes.root}cart.js`)
        .then((res) => res.json())
        .then((cart) => {
          if (!cart || !cart.items || cart.items.length === 0) return;
          const currency = cart.currency || 'EUR';
          const eventId = generarEventId('vc');
          const items = cart.items.map((item) => ({
            item_id: item.sku || String(item.variant_id || item.id),
            item_name: item.product_title || item.title,
            item_brand: item.vendor || 'Olivarte',
            item_category: 'Aceite de Oliva Virgen Extra',
            item_variant: item.variant_title || '',
            price: (item.price || 0) / 100.0,
            quantity: item.quantity
          }));

          window.dataLayer.push({
            event: 'view_cart',
            event_id: eventId,
            ecommerce: {
              currency: currency,
              value: cart.total_price / 100.0,
              items: items
            }
          });
        })
        .catch(() => {});
    } catch (_) {}
  };

  // 6. INICIO DE CHECKOUT (BEGIN_CHECKOUT)
  document.addEventListener('click', (event) => {
    const checkoutBtn = event.target.closest('a[href*="/checkout"], button[name="checkout"], [data-action="checkout"]');
    if (!checkoutBtn) return;

    try {
      const eventId = generarEventId('bc');
      fetch(`${Shopify.routes.root}cart.js`)
        .then((res) => res.json())
        .then((cart) => {
          if (!cart || !cart.items) return;
          const currency = cart.currency || 'EUR';
          const items = cart.items.map((item) => ({
            item_id: item.sku || String(item.variant_id || item.id),
            item_name: item.product_title || item.title,
            item_brand: item.vendor || 'Olivarte',
            item_category: 'Aceite de Oliva Virgen Extra',
            item_variant: item.variant_title || '',
            price: (item.price || 0) / 100.0,
            quantity: item.quantity
          }));

          window.dataLayer.push({
            event: 'begin_checkout',
            event_id: eventId,
            ecommerce: {
              currency: currency,
              value: cart.total_price / 100.0,
              items: items
            }
          });
        })
        .catch(() => {});
    } catch (e) {
      console.warn('[Analytics] Error en begin_checkout:', e);
    }
  });

  // 7. CLIC EN TARJETA DE PRODUCTO (SELECT_ITEM EN HOME, CATÁLOGO Y RECOMENDADOS)
  document.addEventListener('click', (event) => {
    const productLink = event.target.closest('.product-card a, [data-product-card] a, .horizontal-product-card a');
    if (!productLink) return;
    if (event.target.closest('.product-card__quick-add-button, [data-klaviyo-bis-trigger], button[type="submit"]')) return;

    try {
      const card = productLink.closest('.product-card, [data-product-card], .horizontal-product-card');
      if (!card) return;

      const handle = card.getAttribute('handle') || card.dataset.productHandle || productLink.getAttribute('href')?.split('/products/')[1]?.split('?')[0] || '';
      if (!handle) return;

      const { listId, listName } = determinarContextoLista(card);
      const dictData = (window.__olivarteCollectionProducts && window.__olivarteCollectionProducts[handle]) || {};
      const title = card.dataset.productTitle || dictData.name || card.querySelector('.product-card__title, .product-title, h3, h2')?.textContent?.trim() || handle;
      const brand = card.dataset.productBrand || dictData.brand || card.querySelector('.vendor, [class*="vendor"]')?.textContent?.trim() || 'Olivarte';
      const price = card.dataset.productPrice ? parseFloat(card.dataset.productPrice) : (dictData.price || 0);
      const variant = card.dataset.productVariant || dictData.variant || '';
      const itemId = card.dataset.productId || dictData.id || handle;

      window.dataLayer.push({
        event: 'select_item',
        event_id: generarEventId('si'),
        ecommerce: {
          item_list_id: listId,
          item_list_name: listName,
          items: [{
            item_id: handle,
            item_name: title,
            item_brand: brand,
            item_category: 'Aceite de Oliva Virgen Extra',
            item_variant: variant,
            price: Number(price),
            item_list_id: listId,
            item_list_name: listName
          }]
        }
      });
    } catch (_) {}
  });

  // 8. MICRO-EVENTOS: SCROLL DEPTH EN PDP Y CLIC WHATSAPP
  if (window.__olivarteContext?.page_type === 'product') {
    const hitos = [25, 50, 75, 90];
    const hitosDisparados = new Set();

    window.addEventListener('scroll', () => {
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight <= 0) return;
      const pct = Math.round((window.scrollY / docHeight) * 100);

      hitos.forEach((hito) => {
        if (pct >= hito && !hitosDisparados.has(hito)) {
          hitosDisparados.add(hito);
          window.dataLayer.push({
            event: 'scroll_depth_pdp',
            scroll_percentage: hito,
            product_title: window.__olivarteProduct?.title || ''
          });
        }
      });
    }, { passive: true });
  }

  // Clic en WhatsApp Dondy
  document.addEventListener('click', (event) => {
    const wa = event.target.closest('a[href*="whatsapp.com"], a[href*="wa.me"], [id*="dondy-whatsapp"], [class*="whatsapp"]');
    if (!wa) return;

    window.dataLayer.push({
      event: 'whatsapp_chat_click',
      event_id: generarEventId('wa'),
      page_location: window.location.href
    });
  });

  // 9. MEDICIÓN DE RENDIMIENTO DEL UPSELLING EN EL CARRITO (EFECTIVIDAD DE VENTA CRUZADA)
  // A. Impresión del bloque de Upselling (cuando entra en el viewport del drawer)
  const upsellingEl = document.querySelector('upselling-cart-drawer');
  if (upsellingEl && 'IntersectionObserver' in window) {
    const upsellObserver = new IntersectionObserver((entries) => {
      if (entries[0] && entries[0].isIntersecting) {
        window.dataLayer.push({
          event: 'upsell_impression',
          event_id: generarEventId('up_imp'),
          upsell_placement: 'cart_drawer'
        });
        upsellObserver.disconnect();
      }
    }, { threshold: 0.1 });
    upsellObserver.observe(upsellingEl);
  }

  // B. Interacción con el acordeón de Upselling (abrir/cerrar)
  document.addEventListener('click', (event) => {
    const header = event.target.closest('.upselling-cart-drawer__header');
    if (!header) return;
    const card = header.closest('.upselling-cart-drawer__card');
    const isNowCollapsed = card ? card.classList.contains('is-collapsed') : false;
    window.dataLayer.push({
      event: 'upsell_toggle',
      upsell_action: isNowCollapsed ? 'close' : 'open',
      upsell_placement: 'cart_drawer'
    });
  });

  // C. Clic en producto del Upselling para ver detalle
  document.addEventListener('click', (event) => {
    const upsellLink = event.target.closest('upselling-cart-drawer a, .upsell-card a');
    if (!upsellLink || event.target.closest('.upsell-card__circle-add-btn')) return;

    const card = upsellLink.closest('.upsell-card, [data-product-card]');
    const title = card?.querySelector('.product-card__title, .product-title, span')?.textContent?.trim() || '';

    window.dataLayer.push({
      event: 'select_item',
      event_id: generarEventId('si_up'),
      ecommerce: {
        item_list_id: 'cart_upsell',
        item_list_name: 'Cart Upsell Drawer',
        items: [{
          item_name: title,
          item_list_name: 'Cart Upsell Drawer'
        }]
      }
    });
  });

  // 10. PRODUCT DISCOVERY: FILTRADO EN COLECCIONES (FILTER_PRODUCTS)
  document.addEventListener('change', (event) => {
    const input = event.target.closest('facets-form input, .facets input, [id*="facets"] input');
    if (!input) return;

    try {
      const accordion = input.closest('details, .accordion, fieldset') || input.parentElement;
      const filterType = accordion?.querySelector('summary, .accordion__title, [slot="title"], legend')?.textContent?.trim() || 'Filtro';
      
      const labelEl = input.closest('.checkbox-control, label, div')?.querySelector('label, span') || input.nextElementSibling;
      const filterValue = (labelEl?.textContent || input.value || '').replace(/\(\d+\)/g, '').trim();
      const filterAction = input.checked ? 'apply' : 'remove';

      window.dataLayer.push({
        event: 'filter_products',
        event_id: generarEventId('fp'),
        filter_type: filterType,
        filter_value: filterValue,
        filter_action: filterAction,
        collection_name: window.__olivarteCollection?.title || 'Catálogo',
        collection_id: window.__olivarteCollection?.handle || 'all'
      });
    } catch (_) {}
  });

  // 11. PRODUCT DISCOVERY: ORDENACIÓN EN COLECCIONES (SORT_PRODUCTS)
  document.addEventListener('click', (event) => {
    const sortBtn = event.target.closest('.popover__value-option, [role="option"][value]');
    if (!sortBtn || !sortBtn.closest('[id*="sort"], [class*="sort"], [aria-labelledby*="sort"]')) return;

    try {
      const sortBy = sortBtn.getAttribute('value') || '';
      const sortLabel = sortBtn.textContent.trim();

      window.dataLayer.push({
        event: 'sort_products',
        event_id: generarEventId('sp'),
        sort_by: sortBy,
        sort_label: sortLabel,
        collection_name: window.__olivarteCollection?.title || 'Catálogo',
        collection_id: window.__olivarteCollection?.handle || 'all'
      });
    } catch (_) {}
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('select[name="sort_by"]');
    if (!select) return;

    try {
      const sortBy = select.value;
      const sortLabel = select.options[select.selectedIndex]?.text || sortBy;

      window.dataLayer.push({
        event: 'sort_products',
        event_id: generarEventId('sp'),
        sort_by: sortBy,
        sort_label: sortLabel,
        collection_name: window.__olivarteCollection?.title || 'Catálogo',
        collection_id: window.__olivarteCollection?.handle || 'all'
      });
    } catch (_) {}
  });

  // 12. PRODUCT DISCOVERY: BÚSQUEDA INTERNA (SEARCH)
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[action*="/search"], form.search-form');
    if (!form) return;

    try {
      const qInput = form.querySelector('input[name="q"], input[type="search"]');
      const searchTerm = qInput?.value?.trim();
      if (!searchTerm) return;

      window.dataLayer.push({
        event: 'search',
        event_id: generarEventId('srch'),
        search_term: searchTerm
      });
    } catch (_) {}
  });
})();

/* ==========================================================================
 * ORGANIZADOR DE BADGES EN TARJETAS DE PRODUCTO (.product-card)
 * Reúne todos los badges (nativos y generados por apps como Shine Trust) en un
 * contenedor flex unificado arriba a la izquierda (.product-card__badge-container),
 * apilándolos estrictamente en vertical hacia abajo con espaciado limpio y regular.
 * ========================================================================== */
(() => {
  let debounceTimer = null;
  let isUpdating = false;

  function ordenarBadgesTarjetas(root = document) {
    if (isUpdating) return;
    const figures = root.querySelectorAll('.product-card__figure');
    if (!figures.length) return;

    isUpdating = true;
    try {
      figures.forEach((figure) => {
        const stBadges = figure.querySelectorAll('.shine-trust-icon-wrap:not([data-st-organized])');
        const nativeBadgeList = figure.querySelector(':scope > .badge-list');
        let container = figure.querySelector(':scope > .product-card__badge-container');

        if (!stBadges.length && !nativeBadgeList && container) return;
        if (!stBadges.length && !nativeBadgeList && !container) return;

        if (!container) {
          container = document.createElement('div');
          container.className = 'product-card__badge-container';
          figure.insertBefore(container, figure.firstChild);
        }

        // Si existe un .badge-list nativo fuera del contenedor, mover sus elementos dentro
        if (nativeBadgeList && nativeBadgeList.parentNode === figure) {
          while (nativeBadgeList.firstChild) {
            container.appendChild(nativeBadgeList.firstChild);
          }
          nativeBadgeList.remove();
        }

        const card = figure.closest('.product-card');
        const isCardSoldOut = card?.classList.contains('is-sold-out') || card?.getAttribute('data-available') === 'false';

        stBadges.forEach((badge) => {
          badge.dataset.stOrganized = 'true';
          const text = (badge.textContent || '').trim().toLowerCase();
          const isAgotadoBadge = text.includes('agotad') || text.includes('sold out') || (isCardSoldOut && (text === 'agotado' || text === 'agotada'));
          const isRibbonBadge = badge.classList.contains('st-pattern-label-badge-27') ||
            Boolean(badge.querySelector('.st-pattern-label-badge-27')) ||
            text.includes('mejores aceite') ||
            text.includes('mejor aceite') ||
            Boolean(badge.querySelector('[style*="clip-path"]'));

          if (isAgotadoBadge) {
            badge.classList.add('st-badge--agotado-center');
            badge.classList.remove('st-badge--ribbon-right');
            if (badge.parentNode !== figure) {
              figure.appendChild(badge);
            }
            if (card && !card.classList.contains('is-sold-out')) {
              card.classList.add('is-sold-out');
            }
          } else if (isRibbonBadge) {
            badge.classList.add('st-badge--ribbon-right');
            badge.classList.remove('st-badge--agotado-center');
            const patternEl = badge.querySelector('.st-pattern-label-badge-27, [class*="st-pattern-label-badge"]') || badge.querySelector('.patternBadgeItem');
            if (patternEl) {
              patternEl.classList.add('badge--ribbon-clip');
            }
            if (badge.parentNode !== figure) {
              figure.appendChild(badge);
            }
          } else {
            badge.classList.remove('st-badge--agotado-center');
            badge.classList.remove('st-badge--ribbon-right');
            if (badge.parentNode !== container) {
              container.appendChild(badge);
            }
          }
        });

        // Limpiar textos br solo una vez
        figure.querySelectorAll('.st-label-text:not([data-st-cleaned])').forEach((label) => {
          label.dataset.stCleaned = 'true';
          const isRibbon = label.closest('.st-pattern-label-badge-27, .badge--ribbon-clip, .st-badge--ribbon-right');
          if (!isRibbon) {
            if (label.querySelector('br') || /<br\s*\/?>/i.test(label.innerHTML)) {
              label.innerHTML = label.innerHTML.replace(/<br\s*\/?>/gi, ' ').replace(/\s+/g, ' ').trim();
            }
          } else {
            if (label.querySelector('br') || /<br\s*\/?>/i.test(label.innerHTML)) {
              label.innerHTML = label.innerHTML.replace(/<br\s*\/?>/gi, '<br>').replace(/(<br>\s*)+/gi, '<br>').trim();
            }
          }
        });
      });
    } finally {
      isUpdating = false;
    }
  }

  function programarOrdenacion(delay = 40) {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      ordenarBadgesTarjetas(document);
    }, delay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => programarOrdenacion(0));
  } else {
    programarOrdenacion(0);
  }

  window.addEventListener('load', () => programarOrdenacion(50));

  document.addEventListener('shopify:section:load', () => programarOrdenacion(50));
  document.addEventListener('facet:rerender', () => programarOrdenacion(50));
  document.addEventListener('product-list:reorder', () => programarOrdenacion(50));

  const observer = new MutationObserver((mutations) => {
    if (isUpdating) return;
    let hayCambiosBadges = false;
    for (let i = 0; i < mutations.length; i++) {
      const added = mutations[i].addedNodes;
      for (let j = 0; j < added.length; j++) {
        const node = added[j];
        if (node.nodeType === 1) {
          if (node.closest?.('.product-card__badge-container')) continue;
          if (
            (node.classList?.contains('shine-trust-icon-wrap') && !node.dataset.stOrganized) ||
            node.classList?.contains('product-card') ||
            node.querySelector?.('.shine-trust-icon-wrap:not([data-st-organized])')
          ) {
            hayCambiosBadges = true;
            break;
          }
        }
      }
      if (hayCambiosBadges) break;
    }

    if (hayCambiosBadges) {
      programarOrdenacion(30);
    }
  });

  const targetContainer = document.getElementById('main') || document.body;
  observer.observe(targetContainer, { childList: true, subtree: true });
})();

/* ==========================================================================
   FACETS DRAWER: APERTURA DESDE LA IZQUIERDA (ALINEADO AL BOTÓN FILTRAR)
   - Fuerza que cualquier facets-drawer abra y anime siempre desde la izquierda.
   - Intercepta la clase FacetsDrawer para que su propiedad openFrom devuelva 'left',
     activando la animación nativa del tema translateX(-100%) -> translateX(0).
   ========================================================================== */
(() => {
  const forceFacetsDrawerLeft = () => {
    document.querySelectorAll('facets-drawer, #facets-drawer').forEach((drawer) => {
      if (drawer.getAttribute('open-from') !== 'left') {
        drawer.setAttribute('open-from', 'left');
      }
    });
  };

  if (window.customElements) {
    customElements.whenDefined('facets-drawer').then(() => {
      const FacetsDrawerClass = customElements.get('facets-drawer');
      if (FacetsDrawerClass && FacetsDrawerClass.prototype) {
        Object.defineProperty(FacetsDrawerClass.prototype, 'openFrom', {
          get() {
            return 'left';
          },
          configurable: true,
          enumerable: true
        });
      }
      forceFacetsDrawerLeft();
    });
  }

  forceFacetsDrawerLeft();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', forceFacetsDrawerLeft);
  }

  window.addEventListener('load', forceFacetsDrawerLeft);
  document.addEventListener('shopify:section:load', forceFacetsDrawerLeft);
  document.addEventListener('facet:rerender', forceFacetsDrawerLeft);
  document.addEventListener('dialog:before-show', (event) => {
    if (event.target && event.target.matches && event.target.matches('facets-drawer, #facets-drawer')) {
      event.target.setAttribute('open-from', 'left');
    }
  });
})();

/* ==========================================================================
   PLP: ELIMINACIÓN DE OPCIONES DE ORDENACIÓN RELEVANCIA Y ALFABÉTICO
   - Elimina opciones no deseadas del popover de ordenación
   ========================================================================== */
(() => {
  const sanitizeSortOptions = () => {
    const popovers = document.querySelectorAll('facets-sort-popover, #sort-by-popover');
    popovers.forEach((popover) => {
      const options = popover.querySelectorAll('.popover__value-option, [role="option"]');
      options.forEach((opt) => {
        const val = (opt.getAttribute('value') || '').toLowerCase();
        const text = (opt.textContent || '').toLowerCase();
        if (
          val.includes('title-') ||
          val === 'manual' ||
          val === 'relevance' ||
          val === 'featured' ||
          text.includes('relevan') ||
          text.includes('alfabétic') ||
          text.includes('alphabetical') ||
          text.includes('destacad')
        ) {
          opt.remove();
        }
      });
    });
  };

  sanitizeSortOptions();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sanitizeSortOptions);
  }
  window.addEventListener('load', sanitizeSortOptions);
  document.addEventListener('shopify:section:load', sanitizeSortOptions);
  document.addEventListener('facet:rerender', sanitizeSortOptions);
})();

/* ==========================================================================
   JUDGE.ME FEATURED CAROUSEL: ESTILO, CONTROLES ACTIVOS Y ALTURA COMPLETA
   - Control funcional de flechas de carrusel (API nativa Judge.me + fallback)
   - Integra autor y distintivo 'Compra verificada' en la tarjeta al pie
   - Evita el recorte inferior de las tarjetas
   - Oculta por completo la imagen de botella/producto
   ========================================================================== */
(() => {
  let isSyncing = false;

  const slideCarousel = (carouselEl, direction) => {
    if (!carouselEl) return;

    // 1. Intentar usar la API oficial de Judge.me
    const jdgm = window.jdgm;
    const $ = jdgm && jdgm.$ ? jdgm.$ : window.jQuery;
    if (jdgm && $) {
      const $carousel = $(carouselEl);
      if (direction === 1 && typeof jdgm.slideNext === 'function') {
        jdgm.slideNext($carousel);
        return;
      }
      if (direction === -1 && typeof jdgm.slidePrev === 'function') {
        jdgm.slidePrev($carousel);
        return;
      }
      if (typeof jdgm.performSliding === 'function') {
        jdgm.performSliding($carousel, direction, true);
        return;
      }
    }

    // 2. Control de slide directo por transform translate3d si Judge.me aún no expone su API
    const itemWrapper = carouselEl.querySelector('.jdgm-carousel__item-wrapper');
    const items = carouselEl.querySelectorAll('.jdgm-carousel-item');
    if (itemWrapper && items.length > 0) {
      const itemWidth = items[0].getBoundingClientRect().width || (carouselEl.clientWidth / 3);
      const visibleCount = Math.max(1, Math.round(carouselEl.clientWidth / itemWidth));
      const maxSlide = Math.max(0, items.length - visibleCount);
      let currentSlide = parseInt(carouselEl.getAttribute('data-current-slide') || '0', 10);
      let nextSlide = currentSlide + direction;
      if (nextSlide > maxSlide) nextSlide = 0;
      if (nextSlide < 0) nextSlide = maxSlide;
      carouselEl.setAttribute('data-current-slide', nextSlide);
      const offset = nextSlide * itemWidth;
      itemWrapper.style.transition = 'transform 450ms cubic-bezier(0.16, 1, 0.3, 1)';
      itemWrapper.style.transform = `translate3d(-${offset}px, 0px, 0px)`;
    }
  };

  const syncJudgeMeCarousel = () => {
    if (isSyncing) return;
    isSyncing = true;

    try {
      document.querySelectorAll('.jdgm-carousel-wrapper').forEach((wrapper) => {
        const carouselEl = wrapper.querySelector('.jdgm-carousel');
        const arrows = wrapper.querySelector('.jdgm-carousel__arrows');

        // 1. Asegurar que las flechas estén dentro de .jdgm-carousel para posicionamiento y eventos
        if (carouselEl && arrows && !carouselEl.contains(arrows)) {
          carouselEl.appendChild(arrows);
        }

        // 2. Vincular listeners de clic a las flechas (Judge.me + Fallback funcional)
        if (carouselEl) {
          const rightArrow = wrapper.querySelector('.jdgm-carousel__right-arrow');
          const leftArrow = wrapper.querySelector('.jdgm-carousel__left-arrow');

          if (rightArrow && !rightArrow.dataset.clickBound) {
            rightArrow.dataset.clickBound = 'true';
            rightArrow.style.cursor = 'pointer';
            rightArrow.addEventListener('click', (e) => {
              e.preventDefault();
              slideCarousel(carouselEl, 1);
            });
          }

          if (leftArrow && !leftArrow.dataset.clickBound) {
            leftArrow.dataset.clickBound = 'true';
            leftArrow.style.cursor = 'pointer';
            leftArrow.addEventListener('click', (e) => {
              e.preventDefault();
              slideCarousel(carouselEl, -1);
            });
          }
        }

        // 3. Evitar que la caja del carrusel corte el borde inferior de las tarjetas
        const itemContainer = wrapper.querySelector('.jdgm-carousel__item-container');
        const itemWrapper = wrapper.querySelector('.jdgm-carousel__item-wrapper');
        if (itemContainer) {
          itemContainer.style.setProperty('overflow', 'hidden', 'important');
          itemContainer.style.setProperty('padding-bottom', '22px', 'important');
        }
        if (itemWrapper) {
          itemWrapper.style.setProperty('height', 'auto', 'important');
          itemWrapper.style.setProperty('min-height', '250px', 'important');
        }

        // 4. Unificar cada tarjeta: autor al pie con badge, sin botella
        wrapper.querySelectorAll('.jdgm-carousel-item').forEach((item) => {
          const reviewBox = item.querySelector('.jdgm-carousel-item__review');
          const authorWrapper = item.querySelector('.jdgm-carousel-item__reviewer-name-wrapper');
          const product = item.querySelector('.jdgm-carousel-item__product');

          // Ocultar miniatura de botella/producto
          if (product) {
            product.style.display = 'none';
          }

          // Mover autor y distintivo al pie de la tarjeta
          if (reviewBox && authorWrapper && !reviewBox.contains(authorWrapper)) {
            reviewBox.appendChild(authorWrapper);
          }

          // Asegurar distintivo "✓ Compra verificada" idéntico a PDP
          if (authorWrapper) {
            authorWrapper.classList.add('pdp-review__autor');
            let badge = authorWrapper.querySelector('.pdp-review__verificado, .jdgm-verified-badge, .jdgm-carousel-item__buyer-badge, .jdgm-rev__buyer-badge');
            if (!badge) {
              badge = document.createElement('span');
              authorWrapper.appendChild(badge);
            }
            badge.className = 'pdp-review__verificado jdgm-verified-badge';
            badge.textContent = 'Compra verificada';
          }
        });
      });
    } finally {
      setTimeout(() => {
        isSyncing = false;
      }, 50);
    }
  };

  syncJudgeMeCarousel();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncJudgeMeCarousel);
  }
  window.addEventListener('load', syncJudgeMeCarousel);
  document.addEventListener('shopify:section:load', syncJudgeMeCarousel);

  // Observer para el renderizado asíncrono de Judge.me
  if (window.MutationObserver) {
    const observer = new MutationObserver(() => {
      syncJudgeMeCarousel();
    });

    const attachObserver = () => {
      document.querySelectorAll('.jdgm-carousel-wrapper').forEach((w) => {
        observer.observe(w, { childList: true, subtree: true });
      });
    };

    attachObserver();
    window.addEventListener('load', attachObserver);
  }
})();




